import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Multiplecustomization() {
  return (
    <section className="multiple_customization p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Multiple customization options with highly fluid features</h2>
            <p>
              Whether it’s the size of your room or the hues of your paint, the
              interactive client form at Passion Painting has been designed with
              one single aim in mind i.e. to fasten the process of hiring the
              best painter in town for your house makeover.
            </p>
            <p>
              The form has multiple customization options with highly fluid
              features that are easy to use
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="customizefluid_img">
              <StaticImage
                src="../../../images/case-studies/passion-painting/customization_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={945}
                height={612}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Multiplecustomization;
